import FETCH from "../utils/fetch";
import ROUTES from "../config/routes";
import axios from "axios";

const fetchAll = async (params) => {
  const { history, pageNum, limit } = params;

  // console.log("params", params);

  let res = await FETCH.get({
    url: ROUTES.FETCH_ALL_MODULES,
    id: `?pageNum=${pageNum}&limit=${limit}`,
    history: history,
  });
  return res;
};

const fetchFaq = async () => {
  let res = await FETCH.get({
    url: ROUTES.FETCH_FAQ,
  });
  return res;
};

const addProperty = async (params) => {
  const { moduleName, pageNum, limit, body, id } = params;

  console.log("params", params, body);
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");

  let res = await FETCH.post({
    url: ROUTES.CRETE_CLIENT_ITEM,
    id:
      userRole === "Financial Advisor Client"
        ? `?module=${moduleName}&clientId=${ID}`
        : `?module=${moduleName}`,
    body,
  });
  return res;
};

const fetchRooms = async (params) => {
  const { moduleName, pageNum, limit, id, body } = params;
  let res = await FETCH.get({
    url: ROUTES.FETCH_ALL_ROOMS,
    id: `?recordId=${id}`,
    body,
  });
  return res;
};

const fetchDetails = async (id) => {
  let res = await FETCH.get({
    url: ROUTES.FETCH_ALL_ROOMS,
    id: `?recordId=${id}`,
  });
  return res;
};

const fetchItems = async (params) => {
  const { moduleName, pageNum, limit, body } = params;
  // console.log("params", params);
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");

  let res = await FETCH.post({
    url: ROUTES.FETCH_ALL_ITEMS,
    id:
      userRole === "Financial Advisor Client"
        ? `?module=${moduleName}&page=${pageNum}&limit=${limit}&clientId=${ID}`
        : `?module=${moduleName}&page=${pageNum}&limit=${limit}`,
    body,
  });
  return res;
};

const create = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.CREATE_MODULE}?clientId=1`,
    body,
  });
  return res;
};

const update = async (id, body) => {
  let res = await FETCH.put({
    url: ROUTES.UPDATE_MODULE,
    body,
    id,
  });
  return res;
};

const fetchAttributes = async (module) => {
  let res = await FETCH.post({
    url: `${ROUTES.MODULE_ATTRIBUTES}?module=${module}`,
    body: {},
  });
  return res;
};

//Fetch Attributes With SubType
const fetchAttributesWithSubtype = (module, subType) => {
  return FETCH.post({
    url: `${ROUTES.MODULE_ATTRIBUTES}?module=${module}&subType=${subType}`,
    body: {},
  });
};

const createClientItem = async (module, body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.CRETE_CLIENT_ITEM}?module=${module}&clientId=${ID}`
        : `${ROUTES.CRETE_CLIENT_ITEM}?module=${module}`,
    body,
  });
  return res;
};

const updateClientItem = async (recordId, body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  let res = await FETCH.put2({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.UPDATE_CLIENT_ITEM}?recordId=${recordId}&clientId=${ID}`
        : `${ROUTES.UPDATE_CLIENT_ITEM}?recordId=${recordId}`,
    body,
  });
  return res;
};

const getRecordTotal = async (recordId, body) => {
  let res = await FETCH.post({
    url: `${ROUTES.RECORD_TOTAL}?recordId=${recordId}`,
    body,
  });
  return res;
};
const fetchInsuranceStats = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_INSURANCE_STATS}?clientId=${ID}`
        : `${ROUTES.GET_INSURANCE_STATS}`,
  });
  return res;
};
const fetchInsuranceSum = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_INSURANCE_SUM}?clientId=${ID}`
        : `${ROUTES.GET_INSURANCE_SUM}`,
  });
  return res;
};
const fetchInsuranceChart = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_INSURANCE_CHART}?clientId=${ID}`
        : `${ROUTES.GET_INSURANCE_CHART}`,
  });
  return res;
};

const deleteItem = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  let res = await FETCH.deletee({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.DELETE_ITEM}?clientId=${ID}`
        : `${ROUTES.DELETE_ITEM}`,
    body,
  });
  return res;
};

const removeModuleAttribute = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.REMOVE_MODULE_ATTRIBUTES}?clientId=1`,
    body,
  });
  return res;
};

const uploadImage = async (form) => {
  let res = await FETCH.post({
    url: `${ROUTES.IMAGE_UPLOAD}`,
    body: form,
    isFormData: true,
  });
  return res;
};
const uploadFile = async (form) => {
  console.log("form>>>", form);
  let res = await FETCH.post({
    url: `${ROUTES.POST_VIDEO}`,
    body: JSON.stringify(form),
    isFormData: true,
  });
  return res;
};
const uploadProfilePicture = async (form) => {
  let res = await FETCH.SignupPost({
    url: `${ROUTES.POST_PROFILE_PICTURE}`,
    body: JSON.stringify(form),
    isFormData: true,
  });
  return res;
};
const uploadURL = async (url, body, header) => {
  console.log("url", url);
  console.log("body", body);
  let res = await FETCH.put1({
    url,
    body,
    header,
    // isFormData: true,
  });
  return res;
};
const swapCollectibles = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.SWAP_COLLECTIBLES}`,
    body,
  });
  return res;
};

const removeClientModule = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  let res = await FETCH.deletee({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.DELETE_ITEM}?clientId=${ID}`
        : `${ROUTES.DELETE_ITEM}`,
    body,
  });
  return res;
};

const updateClientModule = async (recordId, body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  try {
    let res = await FETCH.put2({
      url:
        userRole === "Financial Advisor Client"
          ? `${ROUTES.UPDATE_CLIENT_ITEM}?recordId=${recordId}&clientId=${ID}`
          : `${ROUTES.UPDATE_CLIENT_ITEM}?recordId=${recordId}`,
      body,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const assetFiledDetails = async (assetName) => {
  try {
    let res = await FETCH.post({
      url: `${ROUTES.ASSET_FIELDS}?module=${assetName}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};

const addAsset = async (module, body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  try {
    let res = await FETCH.post({
      url:
        userRole === "Financial Advisor Client"
          ? `${ROUTES.CRETE_CLIENT_ITEM}?module=${module}&clientId=${ID}`
          : `${ROUTES.CRETE_CLIENT_ITEM}?module=${module}`,
      body,
    });
    return res;
  } catch (error) {
    console.log("error in axios addAsset", error);
  }
};

// In MODULE_API.js
const addAssetWithSubType = async (module, body, subType) => {
  try {
    let res = await FETCH.post({
      url: `${ROUTES.CRETE_CLIENT_ITEM}?module=${module}&subType=${subType}`,
      body,
    });
    return res;
  } catch (error) {
    console.log("error in axios addAssetWithSubType", error);
    throw error;
  }
};

const assetAllocation = async () => {
  try {
    let res = await FETCH.get({
      url: `${ROUTES.FETCH_ALL_ASSET_ALLOCATION}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const insuraceAllocation = async (name) => {
  try {
    let res = await FETCH.get({
      // url: `${ROUTES.FETCH_ALL_ASSET_ALLOCATION}`,
      url: `${ROUTES.FETCH_ALL_ASSET_ALLOCATION}?module=${name}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};

const getTransactionsData = async (id) => {
  try {
    let res = await FETCH.get({
      url: `${`client-module-service/lability-transaction`}?itemId=${id}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const getPayOffData = async () => {
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  try {
    let url = `client-module-service/payoff`;
    // Add clientId if userRole matches
    if (userRole === "Financial Advisor Client" && ID) {
      url += `?clientId=${ID}`;
    }

    let res = await FETCH.get({ url });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};

const createPayOffData = async (body) => {
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  try {
    let url = `client-module-service/payoff`;
    // Add clientId if userRole matches
    if (userRole === "Financial Advisor Client" && ID) {
      url += `?clientId=${ID}`;
    }
    let res = await FETCH.post({
      url,
      body,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const getOneTimeFunding = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  try {
    let url = `client-module-service/onetime-payment?page=1&limit=30`;
    // Add clientId if userRole matches
    if (userRole === "Financial Advisor Client" && ID) {
      url += `&clientId=${ID}`;
    }
    let res = await FETCH.get({ url });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const createOneTimePayment = async (body) => {
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  let url = `client-module-service/onetime-payment`;

  // Add clientId if userRole matches
  if (userRole === "Financial Advisor Client" && ID) {
    url += `?clientId=${ID}`;
  }

  let res = await FETCH.post({
    url,
    body,
  });
  return res;
};

const UpdateOneTimePayment = async (body) => {
  let res = await FETCH.put2({
    url: `${`client-module-service/onetime-payment`}`,
    body,
  });
  return res;
};
const DeleteOneTimePayment = async (id) => {
  let res = await FETCH.deletee({
    url: `${`client-module-service/onetime-payment`}?id=${id}`,
  });
  return res;
};
const deleteCollectable = async (subtype) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.COLLECTABLES_DELETE}?subType=${subtype}`,
  });
  return res;
};
const UpdateAssetGoal = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_ASSET_GOAL}`,
    body,
  });
  return res;
};
const deleteAssetGoal = async (body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.DELETE_GOAL}`,
    body,
  });
  return res;
};
const removeAssignedAsset = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.REMOVE_ASSIGN_ASSET}`,
    body,
  });
  return res;
};
const assignAsset = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.ASSIGN_ASSET}`,
    body,
  });
  return res;
};
const fetchSingleGoalDetails = async (id) => {
  let res = await FETCH.get({
    url: ROUTES.FETCH_SINGLE_GOAL,
    id: `?recordId=${id}`,
  });
  return res;
};
const updateAssignAsset = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.UPDATE_ASSIGN_ASSET}`,
    body,
  });
  return res;
};
const refreshAssetModule = async () => {
  try {
    let res = await FETCH.get({
      url: `${`plaid-service/asset/refresh`}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const assetRefreshCount = async (endpoint) => {
  try {
    let res = await FETCH.get({
      url: `${`plaid-service/request/count?endPoint=${endpoint}`}`,
    });
    return res;
  } catch (error) {
    console.log("error in axios put");
  }
};
const getMonetaryValue = async (date) => {
  let res = await FETCH.post({
    url: `${ROUTES.GET_ASSET_MONETARY_VALUE}?currentDate=${date}`,
  });
  return res;
};
const getTransactionExpanses = async (startDate, endDate) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_EXPANSES}?startDate=${startDate}&endDate=${endDate}&clientId=${ID}`
        : `${ROUTES.GET_EXPANSES}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const getTopExpanses = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.GET_TOP_EXPANSES}`,
    body: body,
  });
  return res;
};
const getFilterBudgets = async (startDate, endDate) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_FILTER_BUDGET}?startDate=${startDate}&endDate=${endDate}&clientId=${ID}`
        : `${ROUTES.GET_FILTER_BUDGET}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const getFilterGoals = async (startDate, endDate) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_FILTER_GOALS}?startDate=${startDate}&endDate=${endDate}&clientId=${ID}`
        : `${ROUTES.GET_FILTER_GOALS}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const getSelectedMonetaryValue = async (date, body) => {
  let res = await FETCH.post({
    url: `${ROUTES.GET_ASSET_MONETARY_VALUE}?currentDate=${date}`,
    body,
  });
  return res;
};
const getDebt = async (startDate, endDate) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.GET_FILTER_DEBT}?startDate=${startDate}&endDate=${endDate}&clientId=${ID}`
        : `${ROUTES.GET_FILTER_DEBT}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const postDebtData = async (id, body) => {
  let res = await FETCH.post({
    url: `${ROUTES.POST_DEBT_DATA}`,
    body,
  });
  return res;
};
const fetchModulesDocs = async (moduleName) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.USER_ATTACHED_DOCS}?type=${moduleName}&clientId=${ID}`
        : `${ROUTES.USER_ATTACHED_DOCS}?type=${moduleName}`,
  });
  return res;
};
const fetchUploadedModulesDocs = async (moduleName, page, otp, query = "") => {
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");

  // Base query parameters
  let params = new URLSearchParams({
    otp: otp,
    page: page,
    limit: 40,
  });

  // Add type and/or fileName if provided
  if (moduleName.trim() !== "") params.append("type", moduleName);
  if (query.trim() !== "") params.append("fileName", query);

  // Add clientId only if userRole matches
  if (userRole === "Financial Advisor Client" && ID) {
    params.append("clientId", ID);
  }

  const res = await FETCH.get({
    url: `${ROUTES.GET_IMP_DOCUMENT}`,
    id: `?${params.toString()}`,
  });

  return res;
};

const uploadModulesDocs = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.UPLOAD_IMP_DOCUMENT}`,
    body,
  });
  return res;
};
const moveModulesDocs = async (id, body) => {
  let res = await FETCH.put2({
    url: `${ROUTES.UPDATE_IMP_DOCUMENT}?id=${id}`,
    body,
  });
  return res;
};
const deleteModulesDocs = async (id) => {
  let res = await FETCH.deletee({
    url: `${ROUTES.DELETE_IMP_DOCUMENT}?documentId=${id}`,
  });
  return res;
};
const fetchModulesDocsCount = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");

  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.COUNT_IMP_DOCUMENT}?clientId=${ID}`
        : `${ROUTES.COUNT_IMP_DOCUMENT}`,
  });
  return res;
};
const fetchFutureLoans = async (page) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");

  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.FETCH_FUTURE_LOAN}?page=${page}&limit=40&clientId=${ID}`
        : `${ROUTES.FETCH_FUTURE_LOAN}?page=${page}&limit=40`,
  });
  return res;
};
const fetchLiabilitySum = async (moduleName) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.CALCULATE_LOAN_SUM}?type=${moduleName}&clientId=${ID}`
        : `${ROUTES.CALCULATE_LOAN_SUM}?type=${moduleName}`,
  });
  return res;
};
const fetchLiabilityCreditSum = async (moduleName) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.CALCULATE_LIABILITY_CREDIT_SUM}?type=${moduleName}&clientId=${ID}`
        : `${ROUTES.CALCULATE_LIABILITY_CREDIT_SUM}?type=${moduleName}`,
  });
  return res;
};
const fetchLiabilityCreditHigherValue = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.LIABILITY_CREDIT_HIGHER_VALUES}?clientId=${ID}`
        : `${ROUTES.LIABILITY_CREDIT_HIGHER_VALUES}`,
  });
  return res;
};
const fetchIncomeSum = async (startDate, endDate) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.INCOME_TOTAL_SUM}?startDate=${startDate}&endDate=${endDate}&clientId=${ID}`
        : `${ROUTES.INCOME_TOTAL_SUM}?startDate=${startDate}&endDate=${endDate}`,
  });
  return res;
};
const fetchIncomeChartData = async (startDate, endDate, type) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let url = `${ROUTES.INCOME_CHART}?startDate=${startDate}&endDate=${endDate}`;
  if (type) {
    url += `&type=${type}`;
  }

  if (userRole === "Financial Advisor Client" && ID) {
    url += `&clientId=${ID}`;
  }
  const res = await FETCH.get({ url });
  // let res = await FETCH.get({
  //   url: type
  //     ? `${ROUTES.INCOME_CHART}?startDate=${startDate}&endDate=${endDate}&type=${type}`
  //     : `${ROUTES.INCOME_CHART}?startDate=${startDate}&endDate=${endDate}`,
  // });
  return res;
};

const fetchUserTotalIncomeExpense = async (startDate, endDate, lastMonth) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let query = `startDate=${startDate}&endDate=${endDate}`;
  if (lastMonth) {
    query += `&lastMonth=true`;
  }
  const url =
    userRole === "Financial Advisor Client"
      ? `${ROUTES.USER_TOTAL_INCOME_EXPENSE}?${query}&clientId=${ID}`
      : `${ROUTES.USER_TOTAL_INCOME_EXPENSE}?${query}`;
  let res = await FETCH.get({ url });

  return res;
};
const fetchUserMontlhySaving = async () => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.USER_MONTHLY_SAVING}?clientId=${ID}`
        : `${ROUTES.USER_MONTHLY_SAVING}`,
  });
  return res;
};

const fetchCategoryWiseLoanBalance = async (module) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.get({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.MODULE_BALANCE}?module=${module}&clientId=${ID}`
        : `${ROUTES.MODULE_BALANCE}?module=${module}`,
  });
  return res;
};

const fetchSampleFile = async (module) => {
  let res = await FETCH.post({
    url: `${ROUTES.COLLECTION_SAMPLE_DOWNLOAD}?module=${module}_item`,
    body: {},
  });
  return res;
};

const uploadCollectionFile = async (body, module) => {
  let res = await FETCH.post({
    url: `${ROUTES.UPLOAD_DOCUMENT}?module=${module}_item`,
    body,
    isFormData: true,
  });
  return res;
};

const loanItemCreate = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.LOAN_ITEM}`,
    body,
  });
  return res;
};
const loanItemUpdate = async (recordId, body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url: `${ROUTES.LOAN_ITEM_UPDATE}?return=true`,
    body,
  });
  return res;
};

const borrowItemCreate = async (body) => {
  let res = await FETCH.post({
    url: `${ROUTES.BORROW_ITEM}`,
    body,
  });
  return res;
};

const getModuleStocks = async (body) => {
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const ID = localStorage.getItem("accessId");
  let res = await FETCH.post({
    url:
      userRole === "Financial Advisor Client"
        ? `${ROUTES.MODULE_STOCKS}?clientId=${ID}`
        : `${ROUTES.MODULE_STOCKS}`,
    body,
  });
  return res;
};

const MODULE_API = {
  addProperty,
  fetchAll,
  fetchItems,
  create,
  update,
  fetchAttributes,
  fetchAttributesWithSubtype,
  removeModuleAttribute,
  uploadImage,
  swapCollectibles,
  fetchFaq,
  fetchRooms,
  removeClientModule,
  createClientItem,
  updateClientItem,
  updateClientModule,
  getRecordTotal,
  deleteItem,
  assetFiledDetails,
  addAsset,
  assetAllocation,
  uploadFile,
  uploadURL,
  fetchDetails,
  insuraceAllocation,
  getTransactionsData,
  getPayOffData,
  createOneTimePayment,
  createPayOffData,
  getOneTimeFunding,
  UpdateOneTimePayment,
  DeleteOneTimePayment,
  UpdateAssetGoal,
  deleteAssetGoal,
  removeAssignedAsset,
  assignAsset,
  fetchSingleGoalDetails,
  updateAssignAsset,
  refreshAssetModule,
  assetRefreshCount,
  getMonetaryValue,
  getTransactionExpanses,
  getTopExpanses,
  getFilterBudgets,
  getFilterGoals,
  getSelectedMonetaryValue,
  getDebt,
  postDebtData,
  fetchModulesDocs,
  uploadModulesDocs,
  moveModulesDocs,
  fetchUploadedModulesDocs,
  deleteModulesDocs,
  fetchFutureLoans,
  fetchLiabilitySum,
  fetchIncomeSum,
  fetchIncomeChartData,
  addAssetWithSubType,
  uploadProfilePicture,
  fetchModulesDocsCount,
  fetchLiabilityCreditSum,
  fetchLiabilityCreditHigherValue,
  fetchInsuranceStats,
  fetchInsuranceSum,
  fetchInsuranceChart,
  fetchUserTotalIncomeExpense,
  deleteCollectable,
  fetchUserMontlhySaving,
  fetchCategoryWiseLoanBalance,
  fetchSampleFile,
  uploadCollectionFile,
  loanItemCreate,
  borrowItemCreate,
  loanItemUpdate,
  getModuleStocks,
};

export default MODULE_API;
